namespace TabAurous.Stock {
    export namespace JewelleryShapeWiseService {
        export const baseUrl = 'Stock/JewelleryShapeWise';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/JewelleryShapeWise/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>JewelleryShapeWiseService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
